import { Route, Routes } from 'react-router-dom';
import Profile from './Profile';
import ProfileDetails from './profileDetails/ProfileDetails';
import Notifications from './notifications/Notifications';
import Notices from './notices/Notices';
import NoticeDetail from './noticeDetail/NoticeDetail';
import Help from './help/Help';
import UserSettings from './userSettings/UserSettings';

const ProfileRoutes = () => (
  <Routes>
    <Route index element={<Profile />} />
    <Route path="details" element={<ProfileDetails />} />
    <Route path="notifications" element={<Notifications />} />
    <Route path="notices" element={<Notices />} />
    <Route path="notices/:noticeId" element={<NoticeDetail />} />
    <Route path="help" element={<Help />} />
    <Route path="settings" element={<UserSettings />} />
  </Routes>
);

export default ProfileRoutes;
